import { NewPageComponent } from '../../templates/new-page/new-page.component';
import { Component, OnInit, ViewChild, ViewContainerRef, ComponentFactoryResolver } from '@angular/core';
import { NgxGalleryOptions, NgxGalleryImage, NgxGalleryAnimation } from 'ngx-gallery';
import { ActivatedRoute } from '@angular/router';
import { ExtraService } from '../../core/services/extra.service';
import { DropDownComponent } from '../../layout/drop-down/drop-down.component';
import { from } from 'rxjs/observable/from';
import { NewPageList } from '../../core/models/new-page-list';
import { ListWithinList } from '../../core/models/list-within-list';
import { Constants } from '../../core/config/Constants';
import { AngularFireDatabase } from 'angularfire2/database';

import { DisclaimerService } from '../../core/services/disclaimer.service';
import { DisableFeatureService } from '../../core/services/disable-feature.service';
import { Disclaimer } from '../../core/models/disclaimer';
import { DisableFeatures } from '../../core/models/disableFeatures';


@Component({
  selector: 'app-disclaimer',
  templateUrl: './disclaimer.component.html',
  styleUrls: ['./disclaimer.component.css'],
  providers: [ExtraService, DisclaimerService, DisableFeatureService]
})
export class DisclaimerComponent implements OnInit{

  public page = {
    title: "Disclaimer",
    slug: "Preferences/Disclaimer"
  };

  disclaimer: Disclaimer = new Disclaimer();
  disableFeatures: DisableFeatures = new DisableFeatures();


  disableButton = false;

  constructor(
    private db: AngularFireDatabase,
    private extraService: ExtraService,
    private route: ActivatedRoute,
    private disclaimerService: DisclaimerService,
    private disableFeaturesService: DisableFeatureService
  ) {

    
    
  }

  eventId :string;


  ngOnInit(){

    this.extraService.changeStateofSideBarButton(true);
		this.extraService.changeSideBar(true);
		this.route.params.subscribe(params => {

      let id = params['eventId'];
      console.log("EventID", id);
      console.log("Params", params);

      this.eventId = id;
      this.disclaimerService.getDisclaimer(id).subscribe(d=>{
        if(d) this.disclaimer = d;
        console.log(d);
      });

      this.disableFeaturesService.getDisableFeatures(id).subscribe(data=>{
        if(data) this.disableFeatures = data;
        console.log(data);
      })

    });
    
  }

  saveAll(){
    this.disableFeaturesService.updateDisableFeatures(this.eventId, this.disableFeatures);
    this.disclaimerService.updateDisclaimer(this.eventId, this.disclaimer);
  }

  addListToDisclaimer(i, list, bool){
    // Do nothing
  }

}






// WEBPACK FOOTER //
// /app/src/app/event/disclaimer/disclaimer.component.ts